export default __webpack_public_path__ + "5862aa6cad5cef444b61559b3b3798d4.png";